import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

@ngCore.Component({
  imports: [ds.input.select.multiple.Component, ds.button.Component],
  selector: 'atn-filter-slideout',
  standalone: true,
  styleUrls: ['./filter-slideout.component.scss'],
  templateUrl: './filter-slideout.component.html',
})
// TODO: This component needs to be refactored so it can use entity collection
export class AtnFilterSlideout {
  // private _store = inject(Store)
  // public readonly purposes = this._store.selectSignal(
  //   state.Reports.Selectors.Reports.Filters.PURPOSES,
  // )
  // public readonly selectedPurposes = this._store.selectSignal(
  //   state.Reports.Selectors.Reports.Filters.INPROGRESS_PURPOSES,
  // )
  // public readonly faCodes = this._store.selectSignal(
  //   state.Reports.Selectors.Reports.Filters.FA_CODES,
  // )
  // public readonly selectedFaCodes = this._store.selectSignal(
  //   state.Reports.Selectors.Reports.Filters.INPROGRESS_FA_CODES,
  // )
  // public readonly loading = this._store.selectSignal(
  //   state.Reports.Selectors.Reports.IS_LOADING,
  // )
  // public purposeChangeHandler(purposes: models.rate.Report.Label.Purpose[]): void {
  //   if (
  //     TypeChecker.Factory.list(models.Report.Label.Purpose.isPurpose)(purposes)
  //   ) {
  //     this._store.dispatch(
  //       state.Reports.Actions.Ui.ListPage.FiltersSlideout.Filters.PurposeFilter.Actions.updated(
  //         {
  //           purposes,
  //         },
  //       ),
  //     )
  //   } else {
  //     throw new Error('Invalid proposals')
  //   }
  // }
  // public faCodeChangeHandler(faCodes: string[]): void {
  //   if (TypeChecker.Factory.list(TypeChecker.isString)(faCodes)) {
  //     this._store.dispatch(
  //       state.Reports.Actions.Ui.ListPage.FiltersSlideout.Filters.FaCodeFilter.Actions.updated(
  //         {
  //           faCodes,
  //         },
  //       ),
  //     )
  //   } else {
  //     throw new Error('Invalid faCodes')
  //   }
  // }
  // public clearClickHandler(): void {
  //   this._store.dispatch(
  //     state.Reports.Actions.Ui.ListPage.FiltersSlideout.ResetButton.Actions.clicked(),
  //   )
  // }
  // public applyHandler(): void {
  //   this._store.dispatch(
  //     state.Reports.Actions.Ui.ListPage.FiltersSlideout.Footer.Buttons.ApplyButton.Actions.clicked(),
  //   )
  // }
}
